module.exports = __webpack_public_path__ + "img/dis2.80a7659d.png";